import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertUsers from "../../../components/usersComponent/insertUsers";
import { translate } from "react-i18next";
// import ReadAxios from "../../../../src/components/axiosComponent/read"
import axios from 'axios'
import {LOCAL_STORAGE} from '../../../utils/constant'

class AddUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
      userMovementTypeIds : []
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
      this.getUserMovementTypes(this.props.location.state.u_id)
    }
  }

  getUserMovementTypes = (userId) => {
    axios.get(`${process.env.REACT_APP_MASTER_API}/userMovementTypeMapping/${userId}?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}`, {
      headers: {
        Authorization: `${LOCAL_STORAGE.userToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }).then((result) => {
      let Ids = [],mappingIds=[]
      result.data.resultSet.map((res)=>{
        Ids.push(res.movementTypeId)
      })
     this.setState({userMovementTypeIds:Ids})
     
    }).catch((err) => {
      console.log(err);
    })
}


  onFormSubmit = () => {
    this.props.history.push("/users");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/users" />
        <div className="m-2">
          <InsertUsers
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
            role={this.state.role}
            action={this.state.title}
            userMovementTypeIds={this.state.userMovementTypeIds}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("create_user")(AddUsers);
